import { render } from "./EmptyPlaceholder.vue?vue&type=template&id=2372590b&scoped=true"
import script from "./EmptyPlaceholder.vue?vue&type=script&lang=js"
export * from "./EmptyPlaceholder.vue?vue&type=script&lang=js"

import "./EmptyPlaceholder.vue?vue&type=style&index=0&id=2372590b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2372590b"]])

export default __exports__